import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa3833e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "allcourse" }
const _hoisted_2 = { class: "selectbox" }
const _hoisted_3 = { class: "statelist" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "类别：", -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "statelist" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "阶段：", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "statelist" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "老师：", -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "pagination-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("li", {
          class: _normalizeClass({'active': _ctx.selectedCategory === ''}),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.categoryChange('')))
        }, "全部", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navData.categoryList, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.code,
            onClick: ($event: any) => (_ctx.categoryChange(item.code)),
            class: _normalizeClass({'active': _ctx.selectedCategory === item.code})
          }, _toDisplayString(item.name), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("li", {
          class: _normalizeClass({'active': _ctx.selectedStep === ''}),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stepChange('')))
        }, "全部", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navData.stepList, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.code,
            onClick: ($event: any) => (_ctx.stepChange(item.code)),
            class: _normalizeClass({'active': _ctx.selectedStep === item.code})
          }, _toDisplayString(item.name), 11, _hoisted_8))
        }), 128))
      ]),
      _createElementVNode("ul", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("li", {
          class: _normalizeClass({'active': _ctx.selectedTeacherLabel === ''}),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.teacherLabelChange('')))
        }, "全部", 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teacherLabelList, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.code,
            onClick: ($event: any) => (_ctx.teacherLabelChange(item.code)),
            class: _normalizeClass({'active': _ctx.selectedTeacherLabel === item.code})
          }, _toDisplayString(item.name), 11, _hoisted_11))
        }), 128))
      ])
    ]),
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_ctx.list.length)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                gutter: 22,
                span: 6,
                courses: _ctx.list,
                onJumpToCourse: _ctx.gotoCourseDetail
              }, null, 8, ["courses", "onJumpToCourse"]))
            : (_openBlock(), _createBlock(_component_Nodata, {
                key: 1,
                class: "nodata",
                mode: "vertical",
                customdesc: '暂无内容'
              }))
        ]),
        (_ctx.total > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_a_pagination, {
                current: _ctx.pageNo,
                "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageNo) = $event)),
                total: _ctx.total,
                pageSize: _ctx.pageSize,
                "show-total": total => `共计${total}条`,
                "show-size-changer": "",
                "page-size-options": ['12', '24', '36', '48'],
                onChange: _ctx.onPageChange,
                onShowSizeChange: _ctx.onPageSizeChange
              }, null, 8, ["current", "total", "pageSize", "show-total", "onChange", "onShowSizeChange"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}